import { TextField } from "@mui/material";
import { ControllerRenderProps } from "react-hook-form";
import __ from "src/utils/Translations";
import { FilterFormSchema } from "src/Pages/Company/Pending/PendingBenefits/types";
import { useTextFieldTagsSupport } from "./useTextFieldTagsSupport";

export const BarcodeIdsField = ({
  field: { ref, name, value = [], onChange },
}: {
  field: ControllerRenderProps<FilterFormSchema, "barcodeIds">;
}) => (
  <TextField
    label={__("Dokument")}
    helperText={__("Użyj klawiszy: Tab, Enter, Spacja lub przecinek aby dodać")}
    {...useTextFieldTagsSupport(value, onChange)}
    fullWidth
    name={name}
    inputRef={ref}
  />
);
